import { GiftingDetails } from '@src/quince-site-common/src/services/cartService/cart.service.types'

import { CustomAttribute } from './CustomAttribute'
import ShopifyEdgeNodeWrapper from './ShopifyEdgeNodeWrapper'
import { IShopifyVariant } from './ShopifyVariant'

export default interface IShopifyCheckout {
  readonly id: string
  readonly subtotalPriceV2: IShopifyPrice
  readonly lineItemsSubtotalPrice: IShopifyPrice
  readonly discountApplications: ShopifyEdgeNodeWrapper<IShopifyDiscountApplication> | undefined
  readonly lineItems: ShopifyEdgeNodeWrapper<IShopifyCheckoutLineItem> | undefined
  readonly webUrl: string
  readonly orderStatusUrl: string | undefined
  readonly updatedAt?: string
  readonly isGift: boolean
  readonly giftingDetails: GiftingDetails
}

export interface IShopifyCheckoutLineItem {
  readonly id: string
  readonly quantity: number
  readonly title: string
  readonly variant: IShopifyVariant
  readonly customAttributes: CustomAttribute[]
  readonly discountAllocations: IShopifyLineItemDiscountAllocation[]
}

export const INVENTORY_STATUS = {
  IN_STOCK: 'IN_STOCK',
  OUT_OF_STOCK: 'OUT_OF_STOCK',
  PARTIAL_OUT_OF_STOCK: 'PARTIAL_OUT_OF_STOCK',
}

export interface IShopifyLineItemDiscountAllocation {
  readonly allocatedAmount: IShopifyLineItemAllocatedAmount
  readonly discountApplication: IShopifyLineItemDiscountApplication
}

export interface IShopifyLineItemAllocatedAmount {
  readonly amount: string
}

export interface IShopifyLineItemDiscountApplication {
  readonly allocationMethod: string
  readonly targetSelection: string
  readonly targetType: string
  readonly title: string
}

export interface IShopifyDiscountApplication {
  readonly code: string
}

interface IShopifyPrice {
  readonly amount: string
}
